<template>
  <div class="fp-contact">
    <tz-banner
      class="tz-banner--small"
      :title="cms.page.title"
      :description="cms.page.subtitle"
      :has-overlay="false"
      :is-light="false"
      :isPageTitle="true"
    />
    <div class="container">
      <div class="fp-contact__content">
        <div
          class="fp-contact__feedback-message"
          v-if="hasFeedback"
          :class="{ error: feedback.isError }"
        >
          {{ feedback.text }}
        </div>
        <h3
          class="fp-contact__heading"
          v-text="
            success
              ? 'Thank you for filling out the contact us form!'
              : cms.page.form_header
          "
        />
        <tz-markdown
          class="fp-contact__text"
          :content="
            success ? 'We will be in touch with you soon.' : cms.page.form_text
          "
        ></tz-markdown>
        <form v-if="!success" @submit.prevent="handleSubmit">
          <div class="fp-contact__form-flex">
            <div class="fp-contact__input-group">
              <img
                aria-hidden="true"
                class="fp-contact__input-group-icon"
                :src="cms.page.form_full_name_icon"
                alt="User Icon"
              />
              <input
                aria-label="Please enter your full name"
                class="fp-contact__input"
                :class="{
                  'fp-contact__input--error': feedback.type === 'name'
                }"
                v-model.trim="fullName"
                placeholder="Full Name"
              />
            </div>
            <div class="fp-contact__input-group">
              <img
                aria-hidden="true"
                class="fp-contact__input-group-icon"
                :src="cms.page.form_email_icon"
                alt="Email Icon"
              />
              <input
                aria-label="Please enter your email address"
                class="fp-contact__input"
                :class="{
                  'fp-contact__input--error': feedback.type === 'email'
                }"
                v-model.trim="email"
                placeholder="Email"
                type="email"
              />
            </div>
          </div>
          <textarea
            aria-label="Please enter your message"
            class="fp-contact__text-area"
            :class="{
              'fp-contact__text-area--error': feedback.type === 'message'
            }"
            v-model.trim="message"
            placeholder="Your Message"
            rows="4"
          ></textarea>
          <button class="fp-contact__submit" type="submit">
            Submit
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import emailSDK from '@/assets/js/shared/services/email-sdk';
import Meta from '@/assets/js/shared/misc/meta.mjs';
const pageCms = require(`@/assets/cms/pages/contact.json`);
const emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
const nameRegex = /^([a-zA-Z\s\-]+)$/;

import TzBanner from '@trazi/tz-banner/src/tz-banner.vue';
import TzMarkdown from '@trazi/tz-markdown/src/tz-markdown.vue';

export default {
  name: 'index',
  components: {
    TzBanner,
    TzMarkdown
  },
  computed: {
    hasFeedback: function() {
      return Object.keys(this.feedback).length !== 0;
    }
  },
  async asyncData({ req }) {
    let parsedResponse = {
      subject: '',
      body: ''
    };
    let body = '';
    let temp = '';

    if (
      process.server &&
      process.env.EMAIL_SDK_SERVER_URL &&
      emailSDK &&
      emailSDK.General
    ) {
      try {
        while ((temp = req.read())) {
          body += temp;
        }
        if (body) {
          parsedResponse = JSON.parse(body);
        }
        if (parsedResponse.subject && parsedResponse.body) {
          await emailSDK.General.email({
            domain: 'freepeoplesearch.com',
            to: 'contact@freepeoplesearch.com',
            subject: parsedResponse.subject,
            body: parsedResponse.body
          });
        }
      } catch (e) {
        console.error(e);
      }
    }

    return parsedResponse;
  },
  data: () => {
    return {
      data: '',
      feedback: {},
      fullName: null,
      email: null,
      message: null,
      success: false
    };
  },
  methods: {
    checkForm: function() {
      this.feedback = {};

      if (!this.fullName) {
        this.feedback = {
          type: 'name',
          text: 'Please enter your name.',
          isError: true
        };
      } else if (!this.validName()) {
        this.feedback = {
          type: 'name',
          text:
            'Please only use letters, spaces, and/or dashes when entering your name',
          isError: true
        };
      } else if (!this.validEmail()) {
        this.feedback = {
          type: 'email',
          text: 'Please enter a valid email address',
          isError: true
        };
      } else if (!this.validMessage()) {
        this.feedback = {
          type: 'message',
          text: 'Please enter a message of 500 characters or less',
          isError: true
        };
      }
    },
    handleSubmit: async function(e) {
      this.checkForm();

      if (!this.hasFeedback) {
        const subject = `FreePeopleSearch Contact Us - ${this.fullName}`;
        const signature = `- ${this.fullName} (${this.email})`;
        const body = `${this.message}<br /><br />${signature}`;
        await this.$http.$post(`${window.location.origin}/contact`, {
          subject,
          body
        });
        this.success = true;
      }

      e.preventDefault();
    },
    validEmail: function() {
      return emailRegex.test(this.email);
    },
    validMessage: function() {
      return (
        this.message !== null &&
        this.message !== '' &&
        this.message.length <= 500
      );
    },
    validName: function() {
      return nameRegex.test(this.fullName);
    }
  },
  props: {
    cms: {
      type: Object,
      default: () => {
        return {
          page: pageCms,
          global: require(`@/assets/cms/global.json`)
        };
      }
    }
  },
  head() {
    return {
      title: this.cms.page.page_title,
      meta: pageCms.meta ? Meta.convertToNuxtMeta(pageCms.meta) : []
    };
  }
};
</script>
